module.exports = __webpack_public_path__ + "static/media/anchorage_marker_light_blue.091bfdc2.svg";